// Отправка записанного аудио на сервер для распознавания (Whisper).

import { authHeaders, config } from '../config'
import { getAccessKey } from './access'

function apiUrl(path: string): string {
  return config.apiBaseUrl ? config.apiBaseUrl + path : path
}

export async function transcribe(blob: Blob, format: string): Promise<string> {
  const b64 = await blobToBase64(blob)
  const r = await fetch(apiUrl('/api/transcribe'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ audioB64: b64, format, accessKey: getAccessKey() }),
  })
  if (!r.ok) throw new Error('Распознавание: HTTP ' + r.status)
  const j = await r.json()
  return String(j.text || '').trim()
}

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const fr = new FileReader()
    fr.onloadend = () => {
      const s = String(fr.result || '')
      resolve(s.slice(s.indexOf(',') + 1)) // отбрасываем префикс data:...;base64,
    }
    fr.onerror = () => reject(new Error('read blob failed'))
    fr.readAsDataURL(blob)
  })
}
